<template>
    <div class="content-wrapper">
        <app-page-top-section :title="$t('product_list')">

            <div class="dropdown d-inline-block btn-dropdown">

                <button class="btn btn-success dropdown-toggle ml-0 mr-2"
                        aria-expanded="false"
                        aria-haspopup="true"
                        data-toggle="dropdown"
                        type="button">
                    {{ $t('action') }}
                </button>

                <div class="dropdown-menu">
                    <a class="dropdown-item d-flex align-items-center p-3" href="#" @click.prevent="exportTableData">
                        <app-icon class="size-15 mr-2" name="upload"/>
                        {{ $t('export_data') || 'Export data' }}
                    </a>
                    <a class="dropdown-item d-flex align-items-center p-3" href="#" @click.prevent="exportTemplate">
                        <app-icon class="size-15 mr-2" name="file-text"/>
                        {{ $t('export_template') || 'Export template' }}
                    </a>
                    <a class="dropdown-item d-flex align-items-center p-3" href="#" @click.prevent="openBulkImport">
                        <app-icon class="size-15 mr-2" name="download"/>
                        {{ $t('import_data') || 'Import data' }}
                    </a>
                </div>
            </div>

            <app-default-button
                v-if="this.$can('create_products')"
                :title="$addLabel('product')"
                :url="('/products/create')"/>

        </app-page-top-section>

        <app-table
            :id="table_id"
            class="table-striped tblProductFixHead"
            :options="options"
            @action="triggerAction"
        />

        <!-- Specification modals -->
        <app-group-modal
            v-if="modalStates.group.isActive"
            v-model="modalStates.group.isActive"
            @close="modalStates.group.isActive = false"
        />

        <app-category-modal
            v-if="modalStates.category.isActive"
            v-model="modalStates.category.isActive"
            @close="modalStates.group.isActive = false"
        />

        <app-sub-category-modal
            v-if="modalStates.subCategory.isActive"
            v-model="modalStates.subCategory.isActive"
            @close="modalStates.subCategory.isActive = false"
        />

        <app-brand-modal
            v-if="modalStates.brand.isActive"
            v-model="modalStates.brand.isActive"
            @close="modalStates.brand.isActive = false"
        />

        <app-unit-create-edit-modal
            v-if="modalStates.unit.isActive"
            v-model="modalStates.unit.isActive"
            @close="modalStates.unit.isActive = false"
        />

        <!-- for deleting product -->
        <app-confirmation-modal
            v-if="confirmationModalActive"
            icon="trash-2"
            modal-id="app-confirmation-modal"
            @cancelled="cancelled"
            @confirmed="confirmed('product-table')"
        />

        <!-- for activating/de-activating product -->
        <app-confirmation-modal
            v-if="Boolean(statusChangeUrl)"
            icon="alert-circle"
            modal-id="app-confirmation-modal"
            :message="$t('are_you_sure_you_want_to_change_the_status')"
            @cancelled="cancelProductStatusChange"
            @confirmed="changeProductStatus"
        />

        <app-cpprice-action-modal v-if="isCppriceActionModalActive" :value="true" :itemData="itemData" @modal-close="closeModal" />

        <import-modal v-if="importDialog" @modal-close="closeImportDialog"/>

        <product-bulk-import-modal v-if="bulkImportDialog" @imported="onBulkImported" @modal-close="closeBulkImport"/>

    </div>
</template>

<script>
import HelperMixin from "../../../../common/Mixin/Global/HelperMixin";
import ProductMixin from "../../Mixins/ProductMixin";
import {
    PRODUCT_EXPORT_ALL,
    PRODUCTS,
    PRODUCT_BULK_EXPORT_DATA,
    PRODUCT_BULK_EXPORT_TEMPLATE,
} from "../../../Config/ApiUrl-CP";

import ProductsModal from "./ProductsModal.vue";
import {axiosDelete, axiosGet, axiosPatch, urlGenerator} from "../../../../common/Helper/AxiosHelper";
import StatusQueryMixin from "../../../../common/Mixin/Global/StatusQueryMixin";
import ImportModal from './ImportModal.vue';
import ProductBulkImportModal from './ProductBulkImportModal.vue';
import { mapGetters } from "vuex";

export default {
    name: "Products",
    mixins: [HelperMixin, ProductMixin, StatusQueryMixin],
    components: {
        ProductsModal,
        ImportModal,
        ProductBulkImportModal
    },
    data() {
        return {
            table_id: 'product-table',
            importDialog: false,
            bulkImportDialog: false,
            isModalActive: false,
            statusChangeUrl: '',
            branchid: 0,
            isPartner: false,
            itemData: [],
            isCppriceActionModalActive: false,
            modalStates: {
                group: {isActive: false,},
                category: {isActive: false,},
                subCategory: {isActive: false,},
                brand: {isActive: false,},
                unit: {isActive: false,},
            },
        }
    },
    computed: {
      ...mapGetters(['getBranchOrWarehouseInfo']),
    },
    watch: {
        getBranchOrWarehouseInfo(val) {
            if(val != undefined && val.branch_type == 'partner') {
                this.isPartner = true;
            } else {
                this.isPartner = false;
            }
        }
    },
    methods: { 
        redirectToImportPage() {
            if(this.isPartner) {
                window.location.replace(urlGenerator('/import/cpproductprice'));
            } else {
                window.location.replace(urlGenerator('/import/product'));
            }
        },
        closeImportDialog(){
            this.importDialog = false
        },
        closeModal(){
            this.isCppriceActionModalActive = false
        },
        exportTableData() {
            window.open(urlGenerator(PRODUCT_BULK_EXPORT_DATA));
        },
        exportTemplate() {
            window.open(urlGenerator(PRODUCT_BULK_EXPORT_TEMPLATE));
        },
        openBulkImport() {
            this.bulkImportDialog = true;
        },
        closeBulkImport() {
            this.bulkImportDialog = false;
        },
        onBulkImported() {
            this.bulkImportDialog = false;
            this.$hub.$emit(`reload-${this.table_id}`);
        },
        changeProductStatus() {
            axiosPatch(this.statusChangeUrl)
                .then(response => {
                    this.toastAndReload(response.data.message, 'product-table');
                    this.statusChangeUrl = '';
                }).catch((error) => {
                if (error.response)
                    this.toastException(error.response.data)
            });
        },
        cancelProductStatusChange() {
            this.statusChangeUrl = '';
        },
        triggerAction(row, action, active) {
            switch (action.name) {
                case 'edit':
                    this.selectedUrl = `${PRODUCTS}/${row.product_id}`;
                    window.location.replace(urlGenerator(`products/edit/${row.product_id}`));
                    break;
                case 'cpprice_action':
                    this.isCppriceActionModalActive = true;
                    this.itemData = row;
                    break;
                case 'deactivate':
                    this.statusChangeUrl = `app/products/${row.id}/change-status?status=${false}`;
                    break;
                case 'activate':
                    this.statusChangeUrl = `app/products/${row.id}/change-status?status=${true}`;
                    break;
                case 'add_to_inventory':
                    break;
                case 'show_stock_overview':
                    return window.location.replace(urlGenerator(`inventory/stock/overview/variant/${row.id}`));
                    break;
                default:
                    this.getAction(row, action, active)
            }
        },
    },
    mounted() {
        this.getProductStatuses();
    }
}
</script>
<style>
.tblProductFixHead .table-responsive.custom-scrollbar { overflow: auto; height: 600px; padding-top: 0 !important;}
.tblProductFixHead .table-responsive.custom-scrollbar table { width: 2000px; }
.tblProductFixHead .table-responsive.custom-scrollbar table thead { position: sticky; top: 0; z-index: 2; background-color: #fff !important; }
.tblProductFixHead .table-responsive.custom-scrollbar table thead tr th:first-child { position: sticky; left: 0; z-index: 2; background-color: #fff !important;}
.tblProductFixHead .table-responsive.custom-scrollbar table tbody tr td:first-child { position: sticky; left: 0; z-index: 1; }
.tblProductFixHead .table-responsive.custom-scrollbar table thead th { padding-top: 2rem !important; }
.tblProductFixHead .table-responsive.custom-scrollbar table tbody tr:nth-child(even) td:first-child { background-color: #fff }
.tblProductFixHead .table-responsive.custom-scrollbar table tbody tr:nth-child(odd) td:first-child { background-color: #f2f2f2 }
</style>